import { render, staticRenderFns } from "./SlotBed.vue?vue&type=template&id=6142478f&scoped=true&"
import script from "./SlotBed.vue?vue&type=script&lang=js&"
export * from "./SlotBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142478f",
  null
  
)

export default component.exports